/** Dev-only analytics console logging. Stripped from useful signal in production. */
export function isAnalyticsDebugEnabled(): boolean {
  return process.env.NODE_ENV === "development";
}

export function logAnalyticsDebug(
  scope: "client" | "server",
  action: string,
  payload: Record<string, unknown>,
): void {
  if (!isAnalyticsDebugEnabled()) return;
  console.info(`[analytics:${scope}] ${action}`, payload);
}
